type ContactEmailLinkProps = {
  value?: string | null;
};

export function ContactEmailLink({ value }: ContactEmailLinkProps) {
  if (!value) {
    return <span>-</span>;
  }

  return (
    <a href={`mailto:${value}`} className="underline underline-offset-4 hover:text-foreground">
      {value}
    </a>
  );
}
